module.exports = __webpack_public_path__ + "img/2.21c36e1a.jpg";